export const isSavingSelector = state => {
	return state.achievementTypes.isSaving;
};

export const errorSelector = state => {
	return state.achievementTypes.error;
};

export const errorsSelector = state => {
	return state.achievementTypes.errors;
};
